import { ProductConstantsType, ColorsConstant } from "../../utility/Constants";
import { SET_THEME, ThemeActionTypes } from "../types/theme.types";

export const setTheme = (product: ProductConstantsType) : ThemeActionTypes  => {
    return ({
        type: SET_THEME,
        payload: ColorsConstant.ColorsByProduct.get(product)
    });
}